import React, { useEffect, useContext } from 'react';
import proptypes from 'prop-types';

import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useDataModel,
  params,
  string as stringType,
  shape as shapeType, } from '@thd-nucleus/data-sources';
import { CtaSection } from '../common/CtaSection';
import { buildServicesLink } from '../../utils/home-services-cta-utils';

const { string, bool, func } = proptypes;

const ScheduleAConsultationCta = ({
  itemId, onClick, hideContactInfo, headerDescription, enableNewTab
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('schedule-a-consultation.ready'); }, []);

  const { path = '' } = useContext(ExperienceContext);
  const opts = {
    variables: {
      itemId
    },
    ssr: true,
  };
  const { data } = useDataModel('product', opts);

  if (!itemId || !data) {
    return null;
  }

  const {
    contactNumber,
    leadGenUrl,
  } = data?.product?.details?.installation;
  const { consultationType = '' } = data?.product?.info;

  if (!leadGenUrl) {
    return null;
  }

  return (
    <CtaSection
      buttonText="Schedule a Consultation"
      contactNumber={contactNumber}
      buttonLink={buildServicesLink({ itemId, leadGenUrl, path, consultationType })}
      onClick={onClick}
      hideContactInfo={hideContactInfo}
      headerDescription={headerDescription}
      openContentInDrawer={!enableNewTab}
      dataComponent="ScheduleAConsultationCta"
    />
  );
};

ScheduleAConsultationCta.displayName = 'ScheduleAConsultationCta';

ScheduleAConsultationCta.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    details: shapeType({
      installation: shapeType({
        contactNumber: stringType(),
        leadGenUrl: stringType()
      }),
    }),
    info: shapeType({
      consultationType: stringType()
    }),
  }),

};

ScheduleAConsultationCta.propTypes = {
  itemId: string.isRequired,
  onClick: func,
  hideContactInfo: bool,
  headerDescription: string,
  enableNewTab: bool
};

ScheduleAConsultationCta.defaultProps = {
  hideContactInfo: false,
  onClick: () => {},
  headerDescription: '',
  enableNewTab: false
};

export { ScheduleAConsultationCta };